import { createContext } from "react";

/**
 * @type{import("react").Context<import("../../../../../types/winQuote").WinQuoteReturnI>}
 */
const WinQuoteContext = createContext();

export default WinQuoteContext;
